import { FormControlProps } from '@mr-yum/frontend-ui'
import { ControllerFieldState, useFormState } from 'react-hook-form'

export interface HookFormName {
  name: string
}

export type HookFormControlProps = HookFormName &
  Pick<FormControlProps, 'label' | 'caption' | 'disabled'>

/*
    setError doesn't "touch" fields. So when we set errors manually after form submission
    we need to check the submit count: https://github.com/react-hook-form/react-hook-form/issues/1418
*/
export const useErrorState = (fieldState: ControllerFieldState) => {
  const { submitCount } = useFormState()
  const isTouchedOrSubmitted = fieldState.isTouched || submitCount > 0
  return !!(isTouchedOrSubmitted && fieldState.error)
}
